<template>
  <tr>
    <td class="koumoku tsukinCont cwT_1">
      <div class="input-group">
        <div class="input-group-prepend">
          <span class="input-group-text" style="height: 30px">自</span>
        </div>
        <input
          type="text"
          class="form-control form-control-sm"
          v-model="item.c_addchg_section_start"
          :disabled="isDisable"
        />
        <div class="input-group-append input-group-prepend">
          <span class="input-group-text" style="height: 30px">～</span>
        </div>
        <input
          type="text"
          class="form-control form-control-sm"
          v-model="item.c_addchg_section_end"
          :disabled="isDisable"
        />
      </div>
    </td>
    <td class="suuryou tsukinCont cwT_2">
      <input
        type="text"
        class="form-control form-control-sm"
        v-model="item.c_addchg_transport"
        :disabled="isDisable"
      />
    </td>
    <td class="tanka tsukinCont cwT_3">
      <Mo_CurrencyInput
        v-model="item.cnvFare"
        class="form-control form-control-sm"
        style="text-align: right"
        :decimal-places="0"
        :allow-negative="false"
        :disabled="isDisable"
      />
    </td>
    <td class="kingaku tsukinCont cwT_4">
      <Mo_CurrencyInput
        v-model="item.cnvPass"
        class="form-control form-control-sm"
        style="text-align: right"
        :decimal-places="0"
        :allow-negative="false"
        :disabled="isDisable"
      />
    </td>
  </tr>
</template>
<script lang="ts">
import { Prop, Options, Vue, Watch } from "vue-property-decorator";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import {
  CONST_OP_TAXRATE,
  CONST_OP_EXPENSES_INVOICE,
  CONST_OP_EXPENSES_TYPE,
} from "furukawa-common/src/common/constant/Constants";
import { EntityRequestAddchgList } from "furukawa-common/src/common/entity/EntityRequestAddchgList";
import Mo_CurrencyInput from "@/components/molecules/Mo_CurrencyInput.vue";

@Options({
  components: {
    vSelect,
    Mo_CurrencyInput,
  },
})
export default class Mo_addchg_row extends Vue {
  //----------------------
  //DOM連携用プロパティ
  //----------------------
  @Prop({ required: true })
  item: EntityRequestAddchgList;
  @Prop({ required: true })
  isDisable: boolean;

  //----------------------
  //セレクトボックス用プロパティ
  //----------------------
  // opTaxtate = CONST_OP_TAXRATE;
  // opInvoice = CONST_OP_EXPENSES_INVOICE;
  // opType = CONST_OP_EXPENSES_TYPE;
  //----------------------
  //モーダル用プロパティ
  //----------------------

  //----------------------
  //制御用メソッド
  //----------------------
  async mounted() {
    //
  }
  /**
   * 再計算イベントが発生した事を上位のコンポーネントに伝えるイベント発生
   */
  @Watch("item.cnvPrice")
  eventCalc() {
    //再計算イベント発生
    //-----------------------
    this.$emit("reCalc");
  }

  //----------------------
  //モーダル用メソッド
  //----------------------
}
</script>
<style scoped>
.tableKeihi tbody tr {
  border-bottom: 1px solid #ccc;
}

.tableKeihi td {
  border-right: 1px solid #ccc;
  height: 20px;
}
.tableKeihi tr > td:last-child {
  border-right: none;
}

.keihiCont > input {
  border: none;
  width: 100%;
}
.cwK_2 {
  min-width: 160px;
  max-width: 160px;
}
.cwK_3 {
  /* width: 20%; */
}
.cwK_4 {
  /* width: 40%; */
}
.cwK_5 {
  /* width: 5%; */
  min-width: 60px;
  max-width: 60px;
}
.cwK_6 {
  /* width: 10%; */
}
.cwK_7 {
  min-width: 100px;
  max-width: 100px;
}
/* .tableKeihi tr:hover td > input,
  .tableKeihi tr:hover td {
    background-color: #dddddd;
  } */

.titleMargin {
  margin: 15px 5px;
}

.titleKubetsu {
  border-radius: 0%;
  padding: 0.5rem;
}
.input-group-text {
  height: 30px;
  padding: 5px;
}

.isEdit input:disabled,
.isEdit textarea:disabled {
  background-color: #fff !important;
  border-top: none !important;
  border-left: none !important;
  border-right: none !important;
  border-radius: 0 !important;
}

.vs--disabled .vs__dropdown-toggle,
.vs--disabled .vs__clear,
.vs--disabled .vs__search,
.vs--disabled .vs__selected,
.vs--disabled .vs__open-indicator {
  background-color: #fff !important;
}
</style>
